import type { MessageKey } from 'types/LocaleMessageKey';

import {
  MESSAGE_HIGHEST_DISCOUNT,
  MESSAGE_SUCCESS_DEFAULT,
} from '@/app/[locale]/product/_consts/discounts';

import type { DiscountError, PdpDiscountData } from './types';

const _showHighestDiscountMessage = (
  { errorMessage, errorType, invalidReason }: DiscountError,
  promotionCodes: (string | null | undefined)[],
  campaign?: string | null | undefined,
) => {
  const hasError = errorType ?? errorMessage ?? invalidReason;

  if (hasError) return true;

  // show sitewide multiple discount message if there are multiple discount codes and one of them is sitewide
  return promotionCodes.length > 1 || campaign;
};

export const _getDiscountAppliedMessage = (
  discountData: PdpDiscountData,
  discountError: DiscountError,
  sitewideDiscount: string,
): MessageKey | null => {
  const { campaign, appliedDiscountCode, promotionCodes } = discountData;
  const defaultMessage = appliedDiscountCode ? MESSAGE_SUCCESS_DEFAULT : null;
  if (
    sitewideDiscount &&
    _showHighestDiscountMessage(discountError, promotionCodes, campaign)
  ) {
    return MESSAGE_HIGHEST_DISCOUNT;
  }

  return defaultMessage;
};
